/**
 * CZNA-217 — MARC field addresses as written in the query line: a tag (`150`), a mask
 * with `X` for any digit (`1XX`, `X50`; `XXX` = any field), optionally followed by one
 * subfield code (`150a`, `1XXa`). Letter tags (`LDR`) are accepted only in upper case,
 * so an ordinary three-letter search word never reads as a field.
 */
var NUMERIC_ADDRESS = /^([0-9xX]{3})([a-z0-9])?$/;
var LETTER_ADDRESS = /^([A-Z][0-9A-Z]{2})([a-z0-9])?$/;
var NUMERIC_TAG = /^[0-9]{3}$/;
export var ANY_FIELD = 'XXX';
/** Parses a word as a field address; undefined when it is not shaped like one. */
export var parseFieldAddress = function (word) {
    var _a;
    var match = (_a = NUMERIC_ADDRESS.exec(word)) !== null && _a !== void 0 ? _a : LETTER_ADDRESS.exec(word);
    if (!match) {
        return undefined;
    }
    var field = match[1].toUpperCase();
    return match[2] ? { field: field, subfield: match[2] } : { field: field };
};
/** Canonical text of an address (`150a`, `1XX`). */
export var formatFieldAddress = function (address) { var _a; return "".concat(address.field).concat((_a = address.subfield) !== null && _a !== void 0 ? _a : ''); };
export var isMask = function (field) { return field.includes('X'); };
/**
 * Catalog tags an address field stands for, in ascending order — the same expansion the
 * backend applies (a mask covers every numeric catalog tag whose digits fit).
 * `null` = any field; an empty array = nothing in the catalog matches.
 */
export var expandField = function (field, catalog) {
    if (field === ANY_FIELD) {
        return null;
    }
    var tags = catalog.fields.map(function (entry) { return entry.tag; });
    if (!isMask(field)) {
        return tags.includes(field) ? [field] : [];
    }
    return tags
        .filter(function (tag) { return NUMERIC_TAG.test(tag); })
        .filter(function (tag) { return field.split('').every(function (char, index) { return char === 'X' || char === tag[index]; }); })
        .sort();
};
